import React from 'react';
import DocumentMeta from 'react-document-meta';

const OG_IMAGE = 'https://memorii-works.com/ogp.png';

interface SeoProps {
  title: string;
  description: string;
  canonical: string;
  noindex?: boolean;
  ogType?: 'website' | 'article';
  ogImage?: string;
  children?: React.ReactNode;
}

const Seo: React.FC<SeoProps> = ({
  title,
  description,
  canonical,
  noindex = false,
  ogType = 'website',
  ogImage = OG_IMAGE,
  children,
}) => {
  const robotsContent = noindex
    ? 'noindex,nofollow,noarchive,noimageindex'
    : 'index,follow';

  const metaObj: any = {
    title,
    description,
    canonical,
    meta: {
      charset: 'utf-8',
      name: {
        robots: robotsContent,
        'twitter:card': 'summary_large_image',
        'twitter:title': title,
        'twitter:description': description,
        'twitter:image': ogImage,
        ...(noindex ? { googlebot: 'noindex,nofollow,noarchive,noimageindex' } : {}),
      },
      property: {
        'og:title': title,
        'og:description': description,
        'og:url': canonical,
        'og:type': ogType,
        'og:image': ogImage,
      },
    },
  };

  if (children) {
    return <DocumentMeta {...metaObj}>{children}</DocumentMeta>;
  }
  return <DocumentMeta {...metaObj} />;
};

export default Seo;
